import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Logo from '../../../assets/images/logo.png';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const LoginHeader: React.FC = () => {
    const navigate = useNavigate();
    return (
        <AppBar position="sticky">
            <Toolbar sx={{ justifyContent: 'space-between', paddingBlock: 2, gap: 2 }}>
                <Box display={'inline-flex'} alignItems={'center'}>
                    <Box component={'span'} display={'inline-flex'} alignItems={'center'} sx={{ cursor: 'pointer' }}>
                        <Typography component={'img'} src={Logo} alt='Logo' onClick={() => navigate('/')} />
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
    );
}

export default LoginHeader;
